module.exports = __webpack_public_path__ + "img/btn-login.446c1e51.jpg";